var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Q2",
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.925,
    height: 27.363,
    viewBox: "0 0 14.925 27.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42954",
    "data-name": "Path 42954",
    d: "M19.463,29.363A7.463,7.463,0,0,1,12,21.9V16.3a4.353,4.353,0,1,1,8.706,0v5.6a1.244,1.244,0,1,1-2.488,0V16.3a1.866,1.866,0,0,0-1.866-1.866A1.928,1.928,0,0,0,14.488,16.3v5.6a4.975,4.975,0,1,0,9.95,0V9.463a4.975,4.975,0,0,0-9.95,0,1.244,1.244,0,0,1-2.488,0,7.463,7.463,0,0,1,14.925,0V21.9A7.463,7.463,0,0,1,19.463,29.363Z",
    transform: "translate(-12 -2)",
    fill: "#008375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAttachment);
export default __webpack_public_path__ + "static/media/document-attachment.1a906bcb6f119d0d908309a883040f25.svg";
export { ForwardRef as ReactComponent };